import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { Validation } from "../models/base.interface";
import { SectionConfig } from "../models/section.interface";
import { PageConfig } from "../models/page.interface";

@Component({
  exportAs: "app-page",
  selector: 'app-page',
  template: `
  <form class="dynamic-form" [formGroup]="pageGroup" (submit)="onSubmit($event)">
  <!--<div>
  <p>{{page.name}} <b>*</b></p>
  <input class="form-control w-100 mb-2">
  </div>-->
  <ng-container *ngFor="let section of page.sections;let i = index" appSection [section]="section" [index]="i" [group]="pageGroup">
  </ng-container>
  </form>
  `,
  styles: []
})
export class PageComponent implements OnInit {
  @Input() page: PageConfig;

  @Output() submit: EventEmitter<any> = new EventEmitter<any>();

  pageGroup: FormGroup;

  get value() {
    return this.pageGroup.value;
  }
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.pageGroup = this.createControl();
  }

  onSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.pageGroup.valid) {
      this.submit.emit(this.pageGroup.value);
    } else {
      this.validateAllFormFields(this.pageGroup);
    }
  }

  createControl() {
    const group = this.fb.group({});
    this.page.sections.forEach(section => {
      section.fields.forEach(field => {
        if (field.type === "button") return;
        const control = this.fb.control(
          field.value,
          this.bindValidations(field.validation || [])
        );
        group.addControl(field.id, control);
      });
      const control = this.fb.control(
        section.name,
        this.bindValidations([])
      );
      group.addControl(section.id, control);
    })
    return group;
  }

  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/page/page.component.ts